import { START_LOADING, STOP_LOADING } from './actionTypes';
import { policyTransactionHistoryService } from '../../services/transactionServices';

export const policyTransactionHistoryAction = (id, page = 0, size = 5) => async (dispatch, getState) => {
    try {
      dispatch({ type: START_LOADING, service: 'START_LOADING' });
      const token = getState().auth.token ||sessionStorage.getItem("token");
      const response = await policyTransactionHistoryService(id, page, size, token);      
      dispatch({ type: 'POLICY_TRANSACTION_HISTORY_SUCCESS', payload: response });
      dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
    } catch (error) {
      dispatch({ type: 'POLICY_TRANSACTION_HISTORY_FAILURE', payload: error.message || 'Transaction service failed. Please try again.' });
    }
  };